import { render, staticRenderFns } from "./block-video.vue?vue&type=template&id=4e4c89ac&scoped=true&"
import script from "./block-video.vue?vue&type=script&lang=js&"
export * from "./block-video.vue?vue&type=script&lang=js&"
import style0 from "./block-video.vue?vue&type=style&index=0&id=4e4c89ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c89ac",
  null
  
)

export default component.exports